import React from "react";
import { Helmet } from "react-helmet";
import { graphql, StaticQuery } from "gatsby";

import Layout from "../../components/Layout";
import FaqRoll from "../../components/FaqRoll/FaqRoll";
import Stage from "../../components/Stage/Stage";

import titleImg from "../../img/FAQ_stage.jpg";
import Container from "../../components/share/Container/Container";
import "./FaqPage.scss";

export default class FaqIndexPage extends React.Component {
  render() {
    return (
      <Layout
        pageTitle="FAQ Poolbau Hannover – Häufige Fragen | Heinze Pool"
        pageDescription="Antworten auf häufige Fragen rund um Poolbau, Wasserpflege und unser Fachgeschäft in Hannover. Heinze Pool GmbH – seit 1968."
        pagePath={this.props.location && this.props.location.pathname}
      >
        <StaticQuery
          query={graphql`
            query FaqSchemaQuery {
              allMarkdownRemark(
                sort: { order: ASC, fields: frontmatter___date }
                filter: { frontmatter: { templateKey: { eq: "faq-post" } } }
              ) {
                edges {
                  node {
                    frontmatter {
                      title
                      description
                    }
                  }
                }
              }
            }
          `}
          render={(data) => {
            const faqItems = data.allMarkdownRemark.edges.map(({ node }) => ({
              "@type": "Question",
              "name": node.frontmatter.title,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": node.frontmatter.description,
              },
            }));
            return (
              <Helmet>
                <script type="application/ld+json">{JSON.stringify({
                  "@context": "https://schema.org",
                  "@type": "FAQPage",
                  "mainEntity": faqItems,
                })}</script>
              </Helmet>
            );
          }}
        />
        <section className="FaqPage">
          <Stage
            title="Häufig gestellte Fragen"
            image={titleImg}
            isStarter={false}
          />
          <Container>
            <div className="content">
              <FaqRoll />
            </div>
          </Container>
        </section>
      </Layout>
    );
  }
}
